import URL from 'url';

export default function getExistingPatientUrl(profileUrl) {
    const parsedUrl = URL.parse(profileUrl, true);
    parsedUrl.query.isNewPatient = 'false';
    // The `search` field takes precedence over the `query` field
    // for URL.format, so we need to delete `parsedUrl.search`.
    delete parsedUrl.search;
    return URL.format(parsedUrl);
}
